'use strict';

//TODO Во всех компонентах привести импорты в порядок, сначала должны идти импорты из React, потом из подключаемых библиотек, потом из наших компонент, потом экшены и прочее. После каждого блока импортов - пустая строка. Макар
//TODO добавить CSS класс, отвечающий за uppercase, добавить его в элементы, где он необходим. из кода Uppercase выпилить. Макар
//TODO убрать из asyncConnect массив промисов, там где этот массив из одного элемента. возвращать просто промис. Макар

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRouterRedux = require('react-router-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/actions/auth');

var _error = require('redux/actions/error');

var _catalog = require('redux/actions/catalog');

var _wish_list = require('redux/actions/wish_list');

var _basket = require('redux/actions/basket');

var _helpers = require('helpers');

var _components2 = require('components');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    App: {
        displayName: 'App'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/App/App.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var App = _wrapComponent('App')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var location = _ref.location,
            _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        var promises = [];
        if (!getState().catalog.catalogIsLoaded) {
            promises.push(dispatch((0, _catalog.getCategories)()));
        }

        // if (getState().catalog.lastCatalogUpdateDate === null) {
        //     promises.push(dispatch(checkCatalogForUpdates()));
        // }

        if (!(0, _auth.isLoaded)(getState()) && (0, _auth.isLoadedInServer)(getState())) {
            promises.push(dispatch((0, _auth.load)()));
        }

        return _promise2.default.all(promises);
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        setting: state.setting,
        user: state.auth.user,
        show_404: state.error.is_show_404,
        currency: state.currency
    };
}, { logout: _auth.logout, pushState: _reactRouterRedux.push, disable404: _error.disable404, wishListFromLocalStorage: _wish_list.wishListFromLocalStorage, basketFromLocalStorage: _basket.basketFromLocalStorage }), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(App, _Component);

    function App() {
        var _ref2;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref2, [this].concat(args))), _this), _this.handleLogout = function (event) {
            event.preventDefault();
            _this.props.logout();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(App, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.wishListFromLocalStorage();
            this.props.basketFromLocalStorage();
            this.mountGoogleMapsScript();
        }
    }, {
        key: '_currentLangToGoogleLangCode',
        value: function _currentLangToGoogleLangCode(langSlug) {
            switch (langSlug) {
                case 'rus':
                    return 'ru';
                case 'eng':
                case 'gbr':
                case 'eur':
                    return 'en';
                case 'kaz':
                    return 'kk';
                case 'ukr':
                    return 'uk';
                default:
                    return 'en';
            }
        }

        // МЕТОД ПРЕДНАЗНАЧЕН ТОЛЬКО ДЛЯ ВЫЗОВА НА КЛИЕНТЕ В componentDidMount!

    }, {
        key: 'mountGoogleMapsScript',
        value: function mountGoogleMapsScript() {
            var currency = this.props.currency;

            var scriptId = 'googleMapsScript';
            var lang = 'en';
            if (!!currency.lang) {
                lang = this._currentLangToGoogleLangCode(currency.lang.slug || 'en');
            }

            var script = document.createElement('script');
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + _config2.default.gapi.key + '&language=' + lang + '&libraries=places';
            script.defer = true;
            script.async = true;
            script.id = scriptId;

            if (!document.getElementById(scriptId)) {
                document.head.appendChild(script);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!this.props.user && nextProps.user) {
                // login
                //this.props.pushState('/loginSuccess');
            } else if (this.props.user && !nextProps.user) {
                // logout
                //this.props.pushState('/');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.location.query.utm_source || this.props.location.query.utm_medium || this.props.location.query.utm_campaign || this.props.location.query.utm_content || this.props.location.query.utm_term) {
                var utm = {
                    utm_source: this.props.location.query.utm_source,
                    utm_medium: this.props.location.query.utm_medium,
                    utm_campaign: this.props.location.query.utm_campaign,
                    utm_content: this.props.location.query.utm_content,
                    utm_term: this.props.location.query.utm_term,
                    time: +new Date()
                };
                _LocalStorageProxy2.default.setItem('utm_redirect_data', (0, _stringify2.default)(utm));
            }

            //todo сделать что бы 404 отображалась только с дроп меню
            var link = ["/", "/category", "/search"],
                // массив страниц, на которых Menu будет статичным
            pattern = /^[\/]\w*/,
                path = this.props.location.pathname.match(pattern),
                drop = true,
                viewSearchAndMenu = this.props.location.pathname !== "/registration" && this.props.location.pathname !== "/slide",
                viewFooter = this.props.location.pathname !== "/slide";

            for (var i = 0; i < link.length; i++) {
                if (path && link[i] === path[0]) {
                    drop = false;
                    break;
                }
            }

            var View = _helpers.ThemeHelper.getViewForContainer('App');
            var _props = this.props,
                user = _props.user,
                setting = _props.setting;


            var description = setting.seoDescription || null;
            var keywords = setting.seoKeywords || null;
            var noindex = setting.seoIndexation === false;

            if (!user && this.props.location.query.payment_in_id) {
                _LocalStorageProxy2.default.setItem('redirect_before_auth', this.props.location.pathname + this.props.location.search);
            }

            return _react3.default.createElement(
                'div',
                { className: 'App u-full-height' },
                keywords ? _react3.default.createElement(_reactHelmet2.default, { meta: [{ name: "keywords", content: keywords }] }) : null,
                description ? _react3.default.createElement(_reactHelmet2.default, { meta: [{ name: "description", content: description }] }) : null,
                noindex ? _react3.default.createElement(_reactHelmet2.default, { meta: [{ name: "robots", content: 'noindex, nofollow' }] }) : null,
                _react3.default.createElement(_reactHelmet2.default, { meta: [{ property: "og:image", content: setting.logo }, { property: "og:image", content: '/android-chrome-512x512.png' }] }),
                _react3.default.createElement(
                    View,
                    { drop: drop, viewSearchAndMenu: viewSearchAndMenu, viewFooter: viewFooter, user: user },
                    _react3.default.createElement(
                        _helpers.NotFoundDecorator,
                        null,
                        _react3.default.createElement(
                            _components2.PreloaderGlobal,
                            null,
                            this.props.children
                        )
                    )
                )
            );
        }
    }]);
    return App;
}(_react2.Component), _class2.propTypes = {
    children: _react2.PropTypes.object.isRequired,
    user: _react2.PropTypes.object,
    logout: _react2.PropTypes.func.isRequired,
    pushState: _react2.PropTypes.func.isRequired,
    currency: _react2.PropTypes.object.isRequired
}, _class2.contextTypes = {
    store: _react2.PropTypes.object.isRequired
}, _temp2)) || _class) || _class));

exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.jsx
// module id = 1797
// module chunks = 0